module.exports = __webpack_public_path__ + "static/img/zz.ea23d32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zz.png
// module id = BrCx
// module chunks = 0